import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "./api";

const chime = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [[880, 0], [1320, 0.13]].forEach(([f, t]) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, ctx.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.12, ctx.currentTime + t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.45);
      o.connect(g).connect(ctx.destination);
      o.start(ctx.currentTime + t);
      o.stop(ctx.currentTime + t + 0.5);
    });
    setTimeout(() => ctx.close(), 1200);
  } catch { /* audio blocked until the user interacts */ }
};

// Polls for new staff email; shows a pop-up + chime and returns the unread count.
export const useMailAlerts = (onOpen, intervalMs = 15000) => {
  const [unread, setUnread] = useState(0);
  const since = useRef("");
  const openRef = useRef(onOpen);
  openRef.current = onOpen;
  useEffect(() => {
    let on = true;
    const tick = () => api.get("/staff/mail-alerts", { params: { since: since.current } }).then(({ data }) => {
      if (!on) return;
      setUnread(data.unread || 0);
      if (since.current && data.new?.length) {
        chime();
        data.new.slice(0, 3).forEach((m) => toast(m.assigned_to_me ? `${m.assigned_by} assigned you an email` : `New email from ${m.from_name || m.from}`, {
          description: m.subject || "(no subject)", duration: 10000, id: `mail-${m.id}`,
          action: { label: "Open", onClick: () => openRef.current?.(m.id) },
        }));
      }
      since.current = data.now;
    }).catch(() => {});
    tick();
    const t = setInterval(tick, intervalMs);
    return () => { on = false; clearInterval(t); };
  }, [intervalMs]);
  useEffect(() => {
    const base = document.title.replace(/^\(\d+\) /, "");
    document.title = unread ? `(${unread}) ${base}` : base;
    return () => { document.title = base; };
  }, [unread]);
  return [unread, setUnread];
};
